import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import claimJobStatusAuditLogListApi from './list/Api.ClaimJobStatusAuditLog.List';

export default class ClaimJobStatusAuditLog
  extends Model<Model.IClaimJobStatusAuditLog>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimJobStatusAuditLog>
{
  id: number;
  oldStatus?: string;
  newStatus?: string;
  createdAtUtc: string;
  modifiedAtUtc: string;
  claimJobId: number;
  createdBy?: User;
  createdById?: number;
  modifiedBy?: User;
  modifiedById?: number;

  constructor(
    data: Partial<Model.IClaimJobStatusAuditLog> | Utils.FormData<Model.IClaimJobStatusAuditLog>,
    language?: Locale.Languages
  ) {
    super(
      {
        createdBy: User,
        modifiedBy: User,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this?.oldStatus,
      info: this?.newStatus,
    };
  }

  static async list(body?: Api.Core.ClaimJobStatusAuditLog.List.IRequest) {
    const { payload, ...rest } = await claimJobStatusAuditLogListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ClaimJobStatusAuditLog(it)),
        count: payload.count,
      },
    };
  }
}
